import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import Home from './components/Home';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/education" element={<Home />} />
          <Route path="/academic-projects" element={<Home />} />
          <Route path="/work-experience" element={<Home />} />
          <Route path="/more-about-me" element={<Home />} />
          <Route path="/skills" element={<Home />} />
          <Route path="/certifications" element={<Home />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
